module.exports = __webpack_public_path__ + "images/logo90276fac214b48bbdd3f63ba6cbe8209.svg";